import { render, staticRenderFns } from "./ReleasesOptions.vue?vue&type=template&id=5d03eb15"
import script from "./ReleasesOptions.vue?vue&type=script&lang=js"
export * from "./ReleasesOptions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports